import { cn } from '@/lib/utils';

type Status =
  | 'connected'
  | 'error'
  | 'syncing'
  | 'disconnected'
  | 'active'
  | 'paused'
  | 'running'
  | 'inactive'
  | 'suspended';

const statusConfig: Record<Status, { label: string; className: string; dotClass: string }> = {
  connected:    { label: 'Connected',    className: 'bg-status-allow/15 text-status-allow',     dotClass: 'bg-status-allow' },
  active:       { label: 'Active',       className: 'bg-status-allow/15 text-status-allow',     dotClass: 'bg-status-allow' },
  syncing:      { label: 'Syncing',      className: 'bg-status-warning/15 text-status-warning', dotClass: 'bg-status-warning animate-pulse' },
  running:      { label: 'Running',      className: 'bg-status-info/15 text-status-info',       dotClass: 'bg-status-info animate-pulse' },
  paused:       { label: 'Paused',       className: 'bg-muted text-muted-foreground',           dotClass: 'bg-muted-foreground' },
  disconnected: { label: 'Disconnected', className: 'bg-muted text-muted-foreground',           dotClass: 'bg-muted-foreground' },
  // Principal lifecycle: SCIM deactivation sets status=inactive ("Deactivated"
  // in SCIM vocabulary); suspended is a temporary administrative hold.
  inactive:     { label: 'Deactivated',  className: 'bg-muted text-muted-foreground',           dotClass: 'bg-muted-foreground' },
  suspended:    { label: 'Suspended',    className: 'bg-status-warning/15 text-status-warning', dotClass: 'bg-status-warning' },
  error:        { label: 'Error',        className: 'bg-destructive/15 text-destructive',       dotClass: 'bg-destructive' },
};

interface StatusBadgeProps {
  status: Status;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig.disconnected;
  return (
    <span className={cn('inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium', config.className, className)}>
      <span className={cn('h-1.5 w-1.5 rounded-full', config.dotClass)} />
      {config.label}
    </span>
  );
}
